import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the default styles
import qaData from '../assets/qa.json';
import javaData from '../assets/java.json';
import databaseData from '../assets/database.json';
import dotnetData from '../assets/dotnet.json';
import CustomMarkdownRenderer from '../components/CustomMarkdownRenderer.js';

function NewUser() {
  const [selectedSkill, setSelectedSkill] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [skillData, setSkillData] = useState({ content: '' });
  const skills = ['QA', 'Java', 'Database', '.NET'];
  const [assessmentResult, setAssessmentResult] = useState(null);
  const [savedMessage, setSavedMessage] = useState(''); // Add this line

  // Combine part1 and part2 into a single content field
  const getSkillContent = (data) => {
    const { User } = data;
    return `${User.part1}\n\n${User.part2}`;
  };

  const handleSkillSelect = (skill) => {
    setSelectedSkill(skill);
    setShowDropdown(false);

    let data = { content: '' };
    switch (skill) {
      case 'QA':
        data = { content: getSkillContent(qaData) };
        break;
      case 'Java':
        data = { content: getSkillContent(javaData) };
        break;
      case 'Database':
        data = { content: getSkillContent(databaseData) };
        break;
      case '.NET':
        data = { content: getSkillContent(dotnetData) };
        break;
      default:
        data = { content: '' };
    }

    setSkillData(data);
  };

  // Load skill data from Local Storage on component mount
  useEffect(() => {
    const storedSkillData = localStorage.getItem(selectedSkill);
    if (storedSkillData) {
      setSkillData(JSON.parse(storedSkillData));
    }
  }, [selectedSkill]);

  // Update the content field of skillData when edited
  const handleUpdateSkillData = (content) => {
    setSkillData((prevData) => ({
      ...prevData,
      content, // Update only the content field
    }));
  };

  const handleUpdateClick = () => {
    // Save the updated skillData to Local Storage
    localStorage.setItem(selectedSkill, JSON.stringify(skillData));
    console.log('Updated Skill Data saved to Local Storage:', skillData);
    setSavedMessage('Data has been saved successfully!'); // Set saved message
    // Optionally, clear the message after a few seconds
    setTimeout(() => {
      setSavedMessage('');
    }, 3000); // Clear message after 3 seconds

  };

  const handleDefaultClick = () => {
    // Save the updated skillData to Local Storage
    localStorage.removeItem(selectedSkill)
    setSavedMessage('Data has been reset to default successfully!'); // Set saved message
    // Optionally, clear the message after a few seconds
    setTimeout(() => {
      setSavedMessage('');
    }, 3000); // Clear message after 3 seconds

  };

  
  const handleReset = () => {
    setSelectedSkill('');
    setSkillData({ content: '' });
    setSavedMessage(''); // Clear saved message on reset
  };

  const isAssessButtonEnabled = selectedSkill;

  return (
    <div>
      {/* Step 1: Select Skill to update */}
      <div className="labels">
        <div className="upload-section">
          <label>Select Skill to Edit/Update</label>
          <div className="custom-dropdown">
            <div className="dropdown-toggle" onClick={() => setShowDropdown((prev) => !prev)}>
              {selectedSkill || 'Select Skill'}
            </div>
            <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
              {skills.map((skill) => (
                <div
                  key={skill}
                  className="dropdown-item"
                  onClick={() => handleSkillSelect(skill)}
                >
                  {skill}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Editable JSON Content */}
      {skillData && (
        <div className="editable-content">
        {selectedSkill && skillData.content ? ( // Check if a skill is selected and content exists
          <>
            {/* <h3>Edit '{selectedSkill}' Skill Data</h3> */}
            <ReactQuill
              value={skillData.content} // Fill the editor with the content from the selected skill
              onChange={handleUpdateSkillData}
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, false] }],
                  ['bold', 'italic', 'underline', 'strike'],
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                  ['blockquote', 'code-block'],
                  ['link', 'image'],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'align': [] }],
                  ['clean'], // Remove formatting button
                ],
              }}
            />
          </>
        ) : (
          <h3></h3> // Optional message when no skill is selected
        )}
      </div>
      
      )}

      {/* Step 2: Update and Reset Buttons */}
      <div style={{ marginTop: '0.90cm' }}>
        <div className="bottom-section">
          <button
            onClick={handleUpdateClick}
            disabled={!isAssessButtonEnabled}
            style={{ backgroundColor: isAssessButtonEnabled ? '#4CAF50' : '#ccc', color: 'white' }}
          >
            Click to Update
          </button>
          <button
            onClick={handleReset}
            style={{ marginLeft: '10px', backgroundColor: '#ff4d4d', color: 'white' }}
          >
            Reset
          </button>
          <button
            onClick={handleDefaultClick}
            style={{ marginLeft: '10px', backgroundColor: '#4ea5ff', color: 'white' }}
          >
            Reset to Defaults
          </button>
        </div>
      </div>
{/* Message indicating data has been saved */}
{savedMessage && (
        <div style={{ marginTop: '12px', color: 'green' }}>
          {savedMessage}
        </div>
      )}


    </div>
  );
}

export default NewUser;
